module.exports = __webpack_public_path__ + "img/financial-and-taxation.31503b99.png";